import React from 'react';
import { connect } from 'react-redux';
import { getSafe } from '@/helpers/global';
import { dataType as types } from '@/constants/data-type';
import { formatFunctions , utilsFunction} from '@/helpers/functions';
import icon_check_normalIcon from '@/assets/images/icons/icon_check_normal.png';
import icon_check_hitIcon from '@/assets/images/icons/icon_check_hit.png';
import Tips from '../../../Tips/Tips';
import { tipsType } from '@/constants/tips-type';
import { appEnvironment } from '@/configurations/app-configs/app.setting.config'
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';
import { IPO_MODE } from '@/constants/app';

class Preview extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    this.state = {
      amountPrice: 0,
      isSelect:false,
      prospectus: [
        {
          id: 0,
          value: false,
          label: 'ipo_apply_preview_prospectus_one'
        },
        {
          id: 1,
          value: false,
          label: 'ipo_apply_preview_prospectus_two'
        },
        {
          id: 2,
          value: false,
          label: 'ipo_apply_preview_prospectus_three'
        },
        {
          id: 3,
          value: false,
          label: 'ipo_apply_preview_prospectus_four_margin'
        }
      ]
    }
  }

  componentDidMount() {
    let amount = this.props.previewData.find(item => item.label === 'common_subscription_amount').value.toString().split(',').join('') * 1000;
    let fee = this.props.previewData.find(item => item.label === 'ipo_service_charge').value * 1000;
    let facilityFee = this.props.previewData.find(item => item.label === 'ipo_facility_fee') ? this.props.previewData.find(item => item.label === 'ipo_facility_fee').value * 1000 : 0
    this.setState({
      amountPrice: (amount + fee + facilityFee) / 1000
    })
  }

  changeProspectus = (index) => {
    let data = this.state.prospectus
    data[index].value = !this.state.prospectus[index].value
    if(this.props.mode === IPO_MODE.APPLY_ACTION){
      data[3].value = true
    }
    this.setState({
      prospectus: data
    })
  }

  selectStatement(){
    this.setState({
      isSelect:!this.state.isSelect
    })
  }

  gotoStatement(e){
    const {language} = this.props
    e.stopPropagation()
    var tempWindow = window.open('_blank')
    let lag = 'eng'
    if(language.title === 'zh_TW'){
      lag = 'tch'
    }else if(language.title === 'zh_CN'){
      lag = 'sch'
    }else{
      lag = 'eng'
    }
    tempWindow.location = iTradeEnv?.thirdPartyLink.replace('as/cc', '')+'html/tc/'+lag+'/ipo-terms-and-conditions.html';
  }

  render() {
    const { language, previewData, ccy, mode, failTips,isSelectStatement } = this.props;
    const { amountPrice, prospectus,isSelect } = this.state;
    const languageMap = { 'EN': 'eng', 'CN': 'sch', 'HK': 'tch' }
    return (
      <React.Fragment>
        <div className='preview-container'>
          <section className="table">
            <ul>
              {
                previewData.map((item, index) =>
                item.label && <li key={index}>
                    <div className="left">{getSafe(() => language[item.label])}</div>
                    <div className="right">{item.value}</div>
                  </li>
                )
              }
            </ul>
            {
               <div className="total-amount-price">
                {getSafe(() => language.common_total_amount_of_payment)}: <span className="price">{utilsFunction.formatNumber(amountPrice, 2)} {ccy}</span>
              </div>
            }

          </section>
          <section className='preview-prospectus-container'>
          <div className={(failTips || isSelectStatement) ? 'errorTitle' : 'title'}>
            {getSafe(() => language.ipo_apply_preview_prospectus_title)}
          </div>
          {
            (failTips || isSelectStatement) && <Tips isNoBgColor type={tipsType.error} style={{ fontSize: '12px' }}>
              {failTips ? language.ipo_apply_prospectus_tips : (isSelectStatement && language.ipo_apply_preview_prospectus_no_select_statement)}
            </Tips>
          }
          <div className="content">
            {
              prospectus.map((item, index) =>
              index === 2 ? 
              <div key={item.id} className="option" onClick={() => this.changeProspectus(index)}>
                <label><img src={item.value ? icon_check_hitIcon : icon_check_normalIcon} alt="check_icon" /></label>
                <div>
                  <p>{getSafe(() => language[item.label])}</p>
                  <p>{language.ipo_apply_preview_prospectus_three_a}</p>
                  <p>{language.ipo_apply_preview_prospectus_three_b}</p>
                  <p>{language.ipo_apply_preview_prospectus_three_c}</p>
                </div>
              </div> :
              index === 3 ?
                <div key={item.id} className="option" onClick={() => this.changeProspectus(index)}>
                  {mode === IPO_MODE.MARGIN_APPLY_ACTION &&<>
                  <label><img src={item.value ? icon_check_hitIcon : icon_check_normalIcon} alt="check_icon" /></label>
                  <div>{getSafe(() => language[item.label])}</div></>}
                </div>
              :
              <div key={item.id} className="option" onClick={() => this.changeProspectus(index)}>
                <label><img src={item.value ? icon_check_hitIcon : icon_check_normalIcon} alt="check_icon" /></label>
                <div>{getSafe(() => language[item.label])}</div>
              </div>
              )
            }
          </div>
          {mode === IPO_MODE.MARGIN_APPLY_ACTION &&
            <div className="statement" onClick={()=>this.selectStatement()}>
              <label><img src={isSelect ? icon_check_hitIcon : icon_check_normalIcon} alt="check_icon" /></label>
              {language.ipo_apply_preview_prospectus_statement_one} {' '}《{' '}<b onClick={e=>this.gotoStatement(e)}>{language.ipo_apply_preview_prospectus_statement_two}</b>{' '}》
            </div>}
        </section>
        </div>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount
  })
)(Preview)
